<template>
  <div v-if="cover && cover?.pictures" class="catalog-banner">
    <DefPicture :result="cover?.pictures" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefPicture from "@components/Def/DefPicture/DefPicture.vue";

export default {
  name: 'CatalogBanner',
  components: { DefPicture },
  props: ['result'],
  computed: {
    ...mapState({
      cover: ({ catalog }) => catalog.data?.catalogSectionList?.banners?.cover,
    }),
  },
};
</script>

<style lang="scss" scoped>
.catalog-banner {
}
</style>
